import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { isACtiveOrganization } from 'modules/actions/statusMenu';
import { useDispatch, useSelector } from 'react-redux';
import { organizationList, organizationTitle } from 'modules/actions/organization';
import { chatList } from 'modules/actions/chat';
const OrganizationButton = ({ boxStyle, item, viewType }) => {
  const { items, id, type } = item;
  const dispatch = useDispatch();

  const onClickEvt = param => {
    if(param !== undefined && param.split('_')[0] === '조직도'){
      const dept = param.split('_');
      dispatch(organizationList(dept[2]));
      dispatch(organizationTitle(dept[2]));
      dispatch(isACtiveOrganization());
    } else {
      const paramSet = {
        inType: 'query',
        inStr: param,
      };
      dispatch(chatList(paramSet));
    }    

/*
    if (param !== '대화종료') {
      const dept = param.split('_');
      dispatch(organizationList(dept[2]));
      dispatch(organizationTitle(dept[2]));
      dispatch(isACtiveOrganization());
    } else {
      const paramSet = {
        inType: 'query',
        inStr: param,
      };
      dispatch(chatList(paramSet));
    }
*/
  };

  return (
    <>
      <div className="_organiz_buttons_div">
        {items !== undefined &&
          items.map((tempItem, idx) => {
            console.log(tempItem);
            return (
              <div className="_organiz_buttons_area" key={`${id}_${idx}_area`}>
                <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value)}>
                  {ReactHtmlParser(tempItem?.button?.label || '')}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};
OrganizationButton.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
OrganizationButton.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default OrganizationButton;
